import { h } from 'preact';
import { ANNOTATION_EVENT } from 'constants/events';
import { IframeAnnotation } from './index';
import { expandable } from 'rendering/behaviors/expandable';
import { ControlBar } from 'rendering/components/adjacent_control_bar';
import { COMPOSITION_TYPES } from 'constants/annotations';

const { IFRAME } = COMPOSITION_TYPES;

@expandable
export class AdjacentIframeAnnotation extends IframeAnnotation {
    static scalable = false

    render() {
        const style = {
            ...this.getElementStyles(),
            width: '100%',
            height: '100%'
        };

        return (
            <div className={ this.classes } style={ style } { ...this.dataAttrs } { ...this.applyActions(this.actions) }>
                <ControlBar onExpand={ this.onExpand } onCollapse={ this.onCollapse } styles={ this.controlBarStyles }/>
                <iframe { ...this.iframeAttrs }/>
            </div>
        );
    }
}